export interface Equals {
  equals?: unknown[] | string | number;
  equalsExact?: string | number;
  exists?: boolean;
}

export interface Where {
  [key: string]: Equals | unknown[];
}

export const whereToAnd = (
  where: Where | null
): { and?: unknown[] } | Record<string, never> => {
  if (!where || Object.keys(where).length === 0) {
    return {};
  }

  const and = Object.keys(where)?.map((key) => {
    const value = where[key];

    // Check if it's an array first
    if (Array.isArray(value)) {
      const or = value.map((item) => {
        return {
          [key]: {
            in: item,
          },
        };
      });

      return {
        or,
      };
    }

    // Now we know it's an Equals object
    const equalsObject = value as Equals;

    if (typeof equalsObject.equalsExact !== "undefined") {
      return {
        [key]: {
          equals: equalsObject.equalsExact,
        },
      };
    }

    if (equalsObject.equals) {
      return {
        [key]: {
          in: equalsObject.equals,
        },
      };
    }

    return {
      [key]: equalsObject,
    };
  });

  return {
    and,
  };
};
